var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 9.00002C2.32843 9.00002 3 8.32844 3 7.50001C3 6.67158 2.32843 6 1.5 6C0.671573 6 0 6.67158 0 7.50001C0 8.32844 0.671573 9.00002 1.5 9.00002Z",
    fill: "#B7B7B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.22705 9.00002C7.05548 9.00002 7.72705 8.32844 7.72705 7.50001C7.72705 6.67158 7.05548 6 6.22705 6C5.39862 6 4.72705 6.67158 4.72705 7.50001C4.72705 8.32844 5.39862 9.00002 6.22705 9.00002Z",
    fill: "#B7B7B7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9546 9.00002C11.783 9.00002 12.4546 8.32844 12.4546 7.50001C12.4546 6.67158 11.783 6 10.9546 6C10.1262 6 9.45459 6.67158 9.45459 7.50001C9.45459 8.32844 10.1262 9.00002 10.9546 9.00002Z",
    fill: "#B7B7B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoints);
export default __webpack_public_path__ + "static/media/points.fefd319c0ae1f16f9a347ee37b71a9fc.svg";
export { ForwardRef as ReactComponent };